import React from 'react'

function TextAreaInput({
    name,
    label,
    placeholder,
    rows,
    disabled,
    value,
    onChange,
    onBlur,
    error,
}) {
    return (
        <div className='flex flex-col space-y-2'>
            <label for={name} className='font-bold flex text-sm md:text-base'>
                <p>{label}</p>
            </label>
            <textarea
                type="text"
                id={name}
                placeholder={placeholder}
                rows={rows}
                className='border border-indigo-600 rounded-lg bg-transparent px-3 py-2 text-sm md:text-base focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500'
                disabled={disabled}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
            />
            {error && (
                <p className='text-xs text-app-brown'>{error}</p>
            )}
        </div>
    )
}

export default TextAreaInput